import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetFacialBiometricIdentification,
	GetFacialBiometricIdentificationResponse,
} from 'domain/usecases/others/facial-biometric/request/get-facial-biometric-identification';

export class RemoteGetFacialBiometricIdentification implements GetFacialBiometricIdentification {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetFacialBiometricIdentificationResponse>,
	) {}

	async get(): Promise<GetFacialBiometricIdentificationResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
